import React, { createContext } from "react";
import { FIREBASE_CONFIG } from "../constants/Config";
import firebase from "firebase";

import "firebase/auth";
import "firebase/firestore";

firebase.initializeApp(FIREBASE_CONFIG);

// if (window.location.hostname === "localhost") {
//   firebase.firestore().useEmulator("localhost", 8080);
//   firebase.functions().useEmulator("localhost", 5001);
//   firebase.auth().useEmulator("http://localhost:9099");
// }

export const firebaseContext = createContext(firebase);

export default function FirebaseContext(props: any) {
  return (
    <firebaseContext.Provider value={firebase}>
      {props.children}
    </firebaseContext.Provider>
  );
}
